export default "__VITE_ASSET__ytH1U08u__"